import { LegacyProductCode } from '@up2stay/up2promo-api-client';
import { isValidHttpUrl } from '@up2stay/up2promo-commons/products';
import { useState } from 'react';
import { Input, Label } from '@up2stay/up2promo-ui';

import { useDictionary } from '@/core/providers/dictionary-provider';
import { isCapacitorNative } from '@/core/utils/capacitor.utils';
import { ProductsSetupStepShell } from '@/routes/app/products-setup-wizard/products-setup-step-shell';

export function ProductsSetupStepCustomUrl({
  productType,
  value,
  onChange,
  error,
  invalidMessage,
}: {
  productType: LegacyProductCode | undefined;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  /** Shown after leaving the field with an invalid URL (DEV-566). */
  invalidMessage?: string;
}) {
  const [touched, setTouched] = useState(false);
  const shownError =
    error ??
    (touched && value.trim() && !isValidHttpUrl(value)
      ? invalidMessage
      : undefined);
  const dict = useDictionary();
  const setup = (dict as { products?: { setup?: Record<string, string> } })
    .products?.setup;
  const title =
    productType === LegacyProductCode.FB
      ? (setup?.customUrlTitleFb ?? setup?.customUrlTitle ?? '')
      : productType === LegacyProductCode.ME
        ? (setup?.customUrlTitleMe ?? setup?.customUrlTitle ?? '')
        : (setup?.customUrlTitle ?? '');
  const description =
    productType === LegacyProductCode.FB
      ? setup?.customUrlDescriptionFb
      : productType === LegacyProductCode.ME
        ? setup?.customUrlDescriptionMe
        : setup?.customUrlDescription;
  const autoFocus = !isCapacitorNative();

  return (
    <ProductsSetupStepShell title={title} description={description}>
      <div className="flex flex-col gap-2">
        <Label htmlFor="setup-custom-url">{setup?.customUrlLabel ?? ''}</Label>
        <Input
          id="setup-custom-url"
          autoFocus={autoFocus}
          type="url"
          inputMode="url"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={() => setTouched(true)}
          placeholder={setup?.customUrlPlaceholder ?? 'https://'}
          aria-invalid={shownError ? true : undefined}
          aria-describedby={shownError ? 'setup-custom-url-error' : undefined}
          className={shownError ? 'border-destructive' : undefined}
          enterKeyHint="done"
        />
        {shownError ? (
          <p
            id="setup-custom-url-error"
            className="text-[13.5px] text-destructive"
          >
            {shownError}
          </p>
        ) : null}
      </div>
    </ProductsSetupStepShell>
  );
}
